<template>
    <el-dropdown :hide-on-click="false">
        <!-- <div class="el-dropdown-link">
            <i class="el-icon-bell"></i>
        </div> -->
        <el-button icon="el-icon-bell"></el-button>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
                v-for="(item, idx) in this.decorated_notification_list"
                :key="idx"
            > 
                <div @click="handle_item_click(item)">
                    {{item.action_description}}
                </div>
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>

import api from '@/api/index'

export default {
    inject: ['reload'],
    components: {
    },
    computed: {
        NOTIFY_FUNCTIONALITY () {
            return 'notification_list_functionality'
        },
        SEE_MORE () {
            return `觀看更多`
        },
        MAX_NOTIFY () {
            return 10
        },
        decorated_notification_list () {
            let list = this.notification_list.slice(0, this.NOTIFY_NUM)
            list.unshift({
                action_description: `您有${this.notification_list.length}則提醒`,
                referenced_table: this.NOTIFY_FUNCTIONALITY,
            })
            if (this.notification_list.length > this.NOTIFY_NUM && this.NOTIFY_NUM < this.MAX_NOTIFY) {
                list.push({
                    action_description: this.SEE_MORE,
                    referenced_table: this.NOTIFY_FUNCTIONALITY,
                })
            }
            return list
        }
    },
    data() {
      return {
          notification_list: [],
          timer: '',
          NOTIFY_NUM: 5,
      }
    },
    async created () {
        this.get_notification_list()
        this.timer = setInterval(this.get_notification_list, 60 * 1000)
    },
    methods: {
        async get_notification_list () {
            console.log('fetch nofication list')
            let res = await api.get_notification_list()
            if (res.success) {
                this.notification_list = res.payload
            }
            else {
                console.log('[ERR] NotificationList: failed to get notification list')
                this.notification_list = []
            }
        },
        cancel_auto_list_get: function() { clearInterval(this.timer) },
        handle_item_click(item) {
            // action_description: "王柏泓 變更：fsdfsdfs 於 公文類"
            // category: "article/edit"
            // created_time: Object
            // fk_user_id: 2
            // id: 133
            // ip_address: "192.168.2.61"
            // referenced_id: "17"
            // referenced_table: "article"
            // updated_time: Object
            console.log('notification item clicked: ', item)

            if (!item['referenced_table']) {
                console.log('[ERR] NotificationList: no reference_table')
                return
            }

            switch(item['referenced_table']) {
            case 'article': 
                this.handle_article_item_click(item)
                //this.reload()
                break
            case 'account': 
                this.handle_account_item_click(item)
                break
            case 'isssue_report': 
                this.handle_isssue_report_item_click(item)
                break
            case this.NOTIFY_FUNCTIONALITY:
                this.handle_notify_functionality_item_click(item)
                break
            default: 
                console.log('[ERR] NotificationList: unknown reference_table')
                break
            }
        },
        async handle_article_item_click(item) {
            if (item['category'] === 'article/online' && item['action_description'].indexOf('上線資料') !== -1) {
                this.backstage_router_push({ path: `/review-management/front-stage-data-publish` })
                return
            }

            if (item['category'] === 'article/delete') {
                this.backstage_router_push({ path: `/digital-resource-management` })
                return
            }

            let res = await api.get_article(item.referenced_id)
            if (res.success) {
                let article_type = res.payload.series_table_name
                this.backstage_router_push({ path: `/digital-resource-management/${article_type}/view/${item.referenced_id}` })
            }
            else {
                console.log('[ERR] NotificationList: failed to get article')
            }
        },
        handle_account_item_click(item) {
            this.backstage_router_push({ path: `/system-management/account-management/view/${item.referenced_id}` })
        },
        handle_isssue_report_item_click(item) {
            if (this.is_current_user_admin()) {
                this.backstage_router_push({ path: `/system-management/issue-report/edit/${item.referenced_id}` })
            }
            else {
                this.backstage_router_push({ path: `/my-issue-report/view/${item.referenced_id}` })
            }
        },
        handle_notify_functionality_item_click (item) {
            if (item['action_description'] === this.SEE_MORE) {
                this.NOTIFY_NUM = this.MAX_NOTIFY
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
    }
  }
</script>

<style lang="scss" scoped>

</style>

